module.exports = __webpack_public_path__ + "img/BlendBuff-Poison.26015afb.png";